import { useState } from "react";
import { getUno } from "../../api/apis";
import { validaGetStatus, hideSideBarDesktop } from "../../utils/funciones";
import { modalCargando } from "../../components/ui/sweetAlerts";
import Swal from "sweetalert2";

export const UseSolicitudesHistoriales = () => {

  const [historialListado, setHistorialListado] = useState([]);

  const traerListadoHistorial = async () => {
    modalCargando("Cargando datos...");
    const respListado = await getUno("getlistadohistorico", { "id_usuario_sap": localStorage.getItem("id_usuario_sap") }, null);
    
    if (!validaGetStatus(respListado)) {
      return;
    }

    setHistorialListado(respListado.data.data);
    hideSideBarDesktop();
    Swal.close();
  };

  return {
    historialListado,
    traerListadoHistorial,
  }
}